import React, { Component } from 'react';
import { useParams, Link } from 'react-router-dom';
import dayjs from 'dayjs';

const STATUS_LABELS = {
    pending: { label:'รอดำเนินการ', color:'#ffc107', icon:'fas fa-clock' },
    contacted: { label:'ติดต่อแล้ว', color:'#17a2b8', icon:'fas fa-phone' },
    quoted: { label:'เสนอราคาแล้ว', color:'#6610f2', icon:'fas fa-file-invoice-dollar' },
    confirmed: { label:'ยืนยันเดินทาง', color:'#28a745', icon:'fas fa-check-circle' },
    closed: { label:'ปิดเคส', color:'#6c757d', icon:'fas fa-times-circle' }
};

class GroupRequestDetailInner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            req: null, activities: [], loading: true,
            note: '', status: '', createdBy: '', saving: false,
            showPicker: false, customers: [], pickerSearch: '', linking: false,
            customerModal: null, customerLoading: false
        };
    }

    openCustomer = (customerId) => {
        this.setState({ customerModal: { loading: true }, customerLoading: true });
        fetch('api/customer/' + customerId)
            .then(r => r.ok ? r.json() : null)
            .then(data => this.setState({ customerModal: data, customerLoading: false }))
            .catch(() => this.setState({ customerModal: null, customerLoading: false }));
    }
    closeCustomer = () => this.setState({ customerModal: null })

    componentDidMount() { this.load(); }

    load() {
        var id = this.props.params?.id;
        if (!id) return;
        this.setState({ loading: true });
        fetch('api/grouprequest/' + id)
            .then(r => r.ok ? r.json() : null)
            .then(j => this.setState({ req: j?.request || null, activities: j?.activities || [], loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    openPicker() {
        this.setState({ showPicker: true });
        if (this.state.customers.length === 0) {
            fetch('api/customer').then(r => r.ok ? r.json() : []).then(customers => this.setState({ customers })).catch(() => {});
        }
    }

    async linkCustomer(customerId) {
        var id = this.props.params?.id;
        this.setState({ linking: true });
        try {
            var r = await fetch('api/grouprequest/' + id + '/link-customer', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ customerId })
            });
            if (!r.ok) throw new Error('link failed');
            this.setState({ linking: false, showPicker: false });
            this.load();
        } catch (e) {
            this.setState({ linking: false });
            alert('ผูกไม่สำเร็จ: ' + e.message);
        }
    }

    async unlinkCustomer() {
        if (!window.confirm('ยกเลิกการผูกกับลูกค้า?')) return;
        var id = this.props.params?.id;
        try {
            await fetch('api/grouprequest/' + id + '/unlink-customer', { method: 'POST' });
            this.load();
        } catch {}
    }

    async createAndLink() {
        if (!window.confirm('สร้างลูกค้าใหม่จากข้อมูลคำขอนี้?')) return;
        var id = this.props.params?.id;
        this.setState({ linking: true });
        try {
            var r = await fetch('api/grouprequest/' + id + '/create-customer', {
                method: 'POST',
                headers: {
                    'X-User-Username': localStorage.getItem('username') || '',
                    'X-User-Display-Name': localStorage.getItem('displayName') || ''
                }
            });
            if (!r.ok) throw new Error('create failed');
            this.setState({ linking: false });
            this.load();
            alert('สร้างลูกค้าใหม่เรียบร้อย');
        } catch (e) {
            this.setState({ linking: false });
            alert('สร้างไม่สำเร็จ: ' + e.message);
        }
    }

    async addActivity() {
        var { note, status, createdBy } = this.state;
        if (!note.trim() && !status) { alert('กรุณาใส่หมายเหตุหรือเปลี่ยนสถานะอย่างน้อย 1 อย่าง'); return; }
        var id = this.props.params?.id;
        this.setState({ saving: true });
        try {
            var r = await fetch('api/grouprequest/' + id + '/activity', {
                method:'POST', headers:{'Content-Type':'application/json'},
                body: JSON.stringify({ note, status, createdBy })
            });
            if (!r.ok) throw new Error('save failed');
            this.setState({ saving: false, note:'', status:'' });
            this.load();
        } catch (e) {
            this.setState({ saving: false });
            alert('บันทึกไม่สำเร็จ: ' + e.message);
        }
    }

    render() {
        var { req, activities, loading, note, status, createdBy, saving, showPicker, customers, pickerSearch, linking, customerModal, customerLoading } = this.state;
        if (loading) return <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>;
        if (!req) return <div className="text-center py-5"><i className="fas fa-exclamation-circle fa-3x text-muted"></i><div className="mt-3">ไม่พบข้อมูล</div></div>;
        var s = STATUS_LABELS[req.status] || STATUS_LABELS.pending;
        var linkedCustomer = req.customerId > 0;
        var filteredCustomers = customers;
        if (pickerSearch.trim()) {
            var ps = pickerSearch.trim().toLowerCase();
            filteredCustomers = customers.filter(c =>
                (c.firstName || '').toLowerCase().includes(ps) ||
                (c.lastName || '').toLowerCase().includes(ps) ||
                (c.nickname || '').toLowerCase().includes(ps) ||
                (c.contacts || []).some(x => (x.value || '').toLowerCase().includes(ps)));
        }

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <Link to="/console/grouprequest" className="btn btn-outline-secondary btn-sm"><i className="fas fa-arrow-left"></i> กลับรายการ</Link>
                    </div>
                    <span style={{ background:s.color, color:'#fff', padding:'6px 16px', borderRadius:20, fontSize:13, fontWeight:700 }}>
                        <i className={s.icon}></i> {s.label}
                    </span>
                </div>

                {/* Customer link panel */}
                <div style={{ background: linkedCustomer ? '#e8f5e9' : '#fff3cd', border: '1px solid ' + (linkedCustomer ? '#c3e6cb' : '#ffeeba'), borderRadius: 10, padding: '14px 18px', marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
                    {linkedCustomer ? (
                        <>
                            <div style={{ fontSize: 14, color: '#155724' }}>
                                <i className="fas fa-link" style={{ color: '#28a745', marginRight: 8 }}></i>
                                ผูกกับลูกค้า: <span style={{ fontWeight: 700, color: '#155724', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => this.openCustomer(req.customerId)}>{req.customerName || 'ID ' + req.customerId}</span>
                            </div>
                            <div className="d-flex" style={{ gap: 8 }}>
                                <button className="btn btn-sm btn-success" onClick={() => this.openCustomer(req.customerId)}><i className="fas fa-user"></i> ดูข้อมูลลูกค้า</button>
                                <Link to={'/console/customer/edit/' + req.customerId} className="btn btn-sm btn-outline-success"><i className="fas fa-edit"></i> แก้ไข</Link>
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => this.unlinkCustomer()}><i className="fas fa-unlink"></i> ยกเลิกผูก</button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div style={{ fontSize: 14, color: '#856404' }}>
                                <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }}></i>
                                ยังไม่ได้ผูกกับลูกค้าในระบบ
                            </div>
                            <div className="d-flex" style={{ gap: 8 }}>
                                <button className="btn btn-sm btn-danger" disabled={linking} onClick={() => this.createAndLink()}>
                                    <i className="fas fa-user-plus"></i> เพิ่มเป็นลูกค้าใหม่
                                </button>
                                <button className="btn btn-sm btn-outline-danger" disabled={linking} onClick={() => this.openPicker()}>
                                    <i className="fas fa-link"></i> ผูกกับลูกค้าที่มีอยู่
                                </button>
                            </div>
                        </>
                    )}
                </div>

                <div className="row">
                    <div className="col-md-5">
                        <div style={{ background:'#fff', borderRadius:10, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)' }}>
                            <h5 style={{ fontWeight:700, marginBottom:16 }}><i className="fas fa-user"></i> ข้อมูลผู้ติดต่อ #{req.id}</h5>
                            <div className="row g-3" style={{ fontSize:14 }}>
                                <div className="col-12"><strong>ชื่อ:</strong> {req.name}</div>
                                <div className="col-md-6"><strong><i className="fas fa-phone"></i> โทร:</strong> {req.phone || '-'}</div>
                                <div className="col-md-6"><strong><i className="fas fa-envelope"></i> อีเมล:</strong> {req.email || '-'}</div>
                                <div className="col-md-6"><strong><i className="fab fa-line"></i> LINE:</strong> {req.line || '-'}</div>
                                <div className="col-md-6"><strong><i className="fas fa-users"></i> จำนวน:</strong> {req.pax > 0 ? req.pax + ' ท่าน' : '-'}</div>
                                <div className="col-md-6"><strong><i className="fas fa-calendar"></i> วันเดินทาง:</strong> {req.travelDate ? dayjs(req.travelDate).format('D MMM YY') : '-'}</div>
                                <div className="col-md-6"><strong><i className="fas fa-coins"></i> งบ:</strong> {req.budget || '-'}</div>
                                <div className="col-12"><strong><i className="fas fa-map-marker-alt"></i> จุดหมาย:</strong> {req.destination || '-'}</div>
                                {req.programCode && (
                                    <div className="col-12"><strong><i className="fas fa-tag"></i> โปรแกรม:</strong> <Link to={'/console/programplus/view/' + req.programId}>{req.programCode} {req.programName}</Link></div>
                                )}
                                {req.note && <div className="col-12"><strong>หมายเหตุจากลูกค้า:</strong><div style={{ background:'#fafafa', padding:10, borderRadius:6, marginTop:4, whiteSpace:'pre-wrap' }}>{req.note}</div></div>}
                                <div className="col-12" style={{ fontSize:12, color:'#888', borderTop:'1px solid #eee', paddingTop:10 }}>
                                    ส่งเมื่อ: {req.createdAt ? dayjs(req.createdAt).format('D MMM YYYY HH:mm') : '-'}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-7">
                        <div style={{ background:'#fff', borderRadius:10, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', marginBottom:16 }}>
                            <h5 style={{ fontWeight:700, marginBottom:16 }}><i className="fas fa-plus-circle"></i> บันทึกกิจกรรม</h5>
                            <div className="mb-2">
                                <label style={{ fontSize:13, fontWeight:600 }}>หมายเหตุ</label>
                                <textarea className="form-control" rows="3" placeholder="เช่น โทรติดต่อลูกค้าแล้ว / ส่งใบเสนอราคา..."
                                    value={note} onChange={e=>this.setState({note:e.target.value})}></textarea>
                            </div>
                            <div className="row g-2 mb-2">
                                <div className="col-md-6 d-flex flex-column">
                                    <label style={{ fontSize:13, fontWeight:600, marginBottom:4, display:'block' }}>เปลี่ยนสถานะ (ถ้ามี)</label>
                                    <select className="form-select" style={{ height:38 }} value={status} onChange={e=>this.setState({status:e.target.value})}>
                                        <option value="">— ไม่เปลี่ยน —</option>
                                        {Object.keys(STATUS_LABELS).map(k => <option key={k} value={k}>{STATUS_LABELS[k].label}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-6 d-flex flex-column">
                                    <label style={{ fontSize:13, fontWeight:600, marginBottom:4, display:'block' }}>ผู้บันทึก</label>
                                    <input className="form-control" style={{ height:38 }} placeholder="ชื่อเจ้าหน้าที่" value={createdBy} onChange={e=>this.setState({createdBy:e.target.value})} />
                                </div>
                            </div>
                            <div className="text-end">
                                <button className="btn btn-danger" disabled={saving} onClick={()=>this.addActivity()}>
                                    <i className="fas fa-save"></i> {saving ? 'กำลังบันทึก...' : 'บันทึกกิจกรรม'}
                                </button>
                            </div>
                        </div>

                        <div style={{ background:'#fff', borderRadius:10, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)' }}>
                            <h5 style={{ fontWeight:700, marginBottom:16 }}><i className="fas fa-history"></i> ประวัติกิจกรรม ({activities.length})</h5>
                            {activities.length === 0 ? (
                                <div style={{ color:'#bbb', textAlign:'center', padding:20 }}>ยังไม่มีบันทึก</div>
                            ) : (
                                <div>
                                    {activities.map(a => {
                                        var ss = STATUS_LABELS[a.status];
                                        return (
                                            <div key={a.id} style={{ borderLeft:'3px solid #dc3545', paddingLeft:12, marginBottom:12 }}>
                                                <div className="d-flex justify-content-between" style={{ fontSize:12, color:'#888' }}>
                                                    <span>{a.createdBy || 'ระบบ'} · {a.createdAt ? dayjs(a.createdAt).format('D MMM YY HH:mm') : ''}</span>
                                                    {ss && <span style={{ background:ss.color, color:'#fff', padding:'2px 8px', borderRadius:12, fontSize:11 }}><i className={ss.icon}></i> {ss.label}</span>}
                                                </div>
                                                {a.note && <div style={{ whiteSpace:'pre-wrap', marginTop:4, fontSize:14 }}>{a.note}</div>}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {customerModal && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1060 }} onClick={this.closeCustomer}>
                        <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: '90%', maxWidth: 700, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <div>
                                    <h5 style={{ margin: 0 }}>
                                        <i className="fas fa-user-circle" style={{ color: '#dc3545' }}></i>
                                        &nbsp;{customerModal.firstName} {customerModal.lastName}
                                        {customerModal.nickname && <span style={{ color: '#888', fontSize: 14, fontWeight: 400, marginLeft: 8 }}>({customerModal.nickname})</span>}
                                    </h5>
                                    {customerModal.customerType && (() => {
                                        var TYPE_META = { individual: { label:'บุคคล', color:'#17a2b8', icon:'fas fa-user' }, organization: { label:'องค์กร', color:'#6610f2', icon:'fas fa-university' }, company: { label:'บริษัท', color:'#dc3545', icon:'fas fa-building' } };
                                        var m = TYPE_META[customerModal.customerType] || TYPE_META.individual;
                                        return <span style={{ background: m.color, color:'#fff', padding:'3px 10px', borderRadius:12, fontSize:11, fontWeight:600, marginTop:6, display:'inline-block' }}><i className={m.icon}></i> {m.label}</span>;
                                    })()}
                                </div>
                                <div className="d-flex" style={{ gap: 8 }}>
                                    <Link to={'/console/customer/edit/' + customerModal.id} className="btn btn-sm btn-outline-primary">
                                        <i className="fas fa-edit"></i> แก้ไข
                                    </Link>
                                    <button className="btn btn-sm btn-outline-secondary" onClick={this.closeCustomer}>×</button>
                                </div>
                            </div>
                            {customerLoading || !customerModal.id ? (
                                <div className="text-center py-4"><div className="spinner-border text-danger"></div></div>
                            ) : (
                                <>
                                    <div className="row g-2 mb-3" style={{ fontSize: 13 }}>
                                        {customerModal.dob && <div className="col-md-6"><strong>วันเกิด:</strong> {dayjs(customerModal.dob).format('D MMM YYYY')}</div>}
                                        {customerModal.gender && <div className="col-md-6"><strong>เพศ:</strong> {customerModal.gender === 'male' ? 'ชาย' : customerModal.gender === 'female' ? 'หญิง' : 'อื่นๆ'}</div>}
                                        {customerModal.idCard && <div className="col-md-6"><strong>เลขบัตรประชาชน:</strong> <code>{customerModal.idCard}</code></div>}
                                        {customerModal.passport && <div className="col-md-6"><strong>Passport:</strong> <code>{customerModal.passport}</code> {customerModal.passportExpiry && <span style={{ color:'#888' }}>(exp: {dayjs(customerModal.passportExpiry).format('D MMM YY')})</span>}</div>}
                                    </div>

                                    <div style={{ fontSize: 13, fontWeight: 700, color: '#555', marginTop: 14, marginBottom: 8 }}><i className="fas fa-phone-alt" style={{ color:'#dc3545' }}></i> ช่องทางติดต่อ</div>
                                    {(customerModal.contacts || []).length === 0 ? (
                                        <div style={{ color: '#bbb', fontSize: 13 }}>ยังไม่มีข้อมูลติดต่อ</div>
                                    ) : (
                                        <div style={{ display:'flex', flexDirection:'column', gap: 8 }}>
                                            {customerModal.contacts.map((c, i) => {
                                                var ICON = { phone:'fas fa-phone', line:'fab fa-line', email:'fas fa-envelope', fax:'fas fa-fax', address:'fas fa-map-marker-alt', facebook:'fab fa-facebook', other:'fas fa-comment-alt' };
                                                var COLOR = { phone:'#28a745', line:'#06c755', email:'#dc3545', fax:'#6c757d', address:'#ff9800', facebook:'#1877f2', other:'#888' };
                                                return (
                                                    <div key={i} style={{ background:'#fafbfc', border:'1px solid #eee', borderRadius:8, padding:'10px 14px', display:'flex', alignItems:'center', gap:12 }}>
                                                        <div style={{ width:32, height:32, borderRadius:'50%', background:COLOR[c.type]||'#888', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><i className={ICON[c.type]||'fas fa-circle'}></i></div>
                                                        <div style={{ flex:1, minWidth: 0 }}>
                                                            <div style={{ fontSize:14, fontWeight:600 }}>{c.value}</div>
                                                            {c.note && <div style={{ fontSize:11, color:'#888' }}>{c.note}</div>}
                                                        </div>
                                                        {c.type === 'phone' && <a href={'tel:'+c.value} className="btn btn-sm btn-outline-success" title="โทร"><i className="fas fa-phone"></i></a>}
                                                        {c.type === 'email' && <a href={'mailto:'+c.value} className="btn btn-sm btn-outline-danger" title="ส่งอีเมล"><i className="fas fa-envelope"></i></a>}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    {customerModal.note && (
                                        <>
                                            <div style={{ fontSize: 13, fontWeight: 700, color: '#555', marginTop: 14, marginBottom: 8 }}><i className="fas fa-sticky-note" style={{ color:'#dc3545' }}></i> หมายเหตุ</div>
                                            <div style={{ background:'#fff9e6', border:'1px solid #ffe5a0', borderRadius:8, padding: 12, whiteSpace: 'pre-wrap', fontSize: 13, color:'#555' }}>{customerModal.note}</div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}

                {showPicker && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 }} onClick={() => this.setState({ showPicker: false })}>
                        <div style={{ background: '#fff', borderRadius: 12, padding: 20, width: '90%', maxWidth: 700, maxHeight: '85vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 style={{ margin: 0 }}><i className="fas fa-search"></i> เลือกลูกค้าที่มีอยู่</h5>
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => this.setState({ showPicker: false })}>×</button>
                            </div>
                            <div className="input-group mb-3">
                                <span className="input-group-text"><i className="fas fa-search"></i></span>
                                <input className="form-control" placeholder="ค้นหา ชื่อ / เบอร์ / อีเมล / LINE" autoFocus
                                    value={pickerSearch} onChange={e => this.setState({ pickerSearch: e.target.value })} />
                            </div>
                            <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #eee', borderRadius: 8 }}>
                                {filteredCustomers.length === 0 ? (
                                    <div className="text-center py-5" style={{ color: '#bbb' }}><i className="fas fa-user-slash fa-2x"></i><div className="mt-2">ไม่พบลูกค้า</div></div>
                                ) : filteredCustomers.map(c => {
                                    var phone = (c.contacts || []).find(x => x.type === 'phone');
                                    var email = (c.contacts || []).find(x => x.type === 'email');
                                    return (
                                        <div key={c.id} onClick={() => this.linkCustomer(c.id)}
                                            style={{ padding: '10px 14px', borderBottom: '1px solid #f0f0f0', cursor: 'pointer', transition: 'background 0.1s' }}
                                            onMouseEnter={e => e.currentTarget.style.background = '#fff5f5'}
                                            onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                                            <div style={{ fontWeight: 600 }}>
                                                <i className="fas fa-user-circle" style={{ color: '#aaa', marginRight: 6 }}></i>
                                                {c.firstName} {c.lastName}
                                                {c.nickname && <span style={{ color: '#888', fontSize: 12, marginLeft: 6 }}>({c.nickname})</span>}
                                            </div>
                                            <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>
                                                {phone && <span style={{ marginRight: 12 }}><i className="fas fa-phone"></i> {phone.value}</span>}
                                                {email && <span><i className="fas fa-envelope"></i> {email.value}</span>}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="text-end mt-3">
                                <button className="btn btn-outline-secondary" onClick={() => this.setState({ showPicker: false })}>ยกเลิก</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export function GroupRequestDetail(props) {
    var params = useParams();
    return <GroupRequestDetailInner {...props} params={params} />;
}
